import { createAction, props } from '@ngrx/store';
import { FlowMetersModel, PressureSensorsModel, PumpSystemsModel, ZoneModel } from '../_models';

export const loadXidroDevices = createAction('[Xidro] Load Devices');

export const loadXidroDevicesSuccess = createAction(
  '[Xidro] Load Devices Success',
  props<{
    pumpSystems: PumpSystemsModel[];
    pressureMeters: PressureSensorsModel[];
    valves: ZoneModel[];
    flowMeters: FlowMetersModel[];
  }>()
);

export const loadXidroDevicesFailure = createAction(
  '[Xidro] Load Devices Failure',
  props<{ error: string }>()
);
